import { Grid, Button, TextField } from "@material-ui/core"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { obtenerAereosClaveViajeAction } from "../../../ducks/aereosDuck"
import {offLoadAction, onLoadAnction} from "./../../../ducks/loadDuck"
const FiltroAereo = () => {
    const [busqueda, setBusqueda] = useState("NA")
    const [buscador, setBuscador] = useState("")
    const dispatch = useDispatch()
    const handleFiltro = () => {
        dispatch(onLoadAnction({message: ""}))
        dispatch(obtenerAereosClaveViajeAction({ claveViaje: (busqueda === "NA") ? "NA" : busqueda})).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const onChange = (event) =>{
        setBusqueda((event.target.value.length > 0) ? event.target.value : "NA")
        setBuscador((event.target.value.length > 0) ? event.target.value : "")
    }
    return (
        <div>
            <Grid
                style={{ margin: "2% 0" }}
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center">
                <Grid item xs={1}>
                    <Button onClick={handleFiltro} color="primary">Filtrar</Button>
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        id="FielBusqueda"
                        label="Buscar grupo"
                        variant="outlined"
                        name="busqueda"
                        style={{ width: "100%", margin: "5px 0" }}
                        value={buscador}
                        onChange={(e) => onChange(e)}
                    />
                </Grid>
            </Grid>
        </div>
    )
}
export default FiltroAereo